import {
    Button,
    Flex,
    NumberInput,
    Select,
    SelectItem,
    Text,
    Textarea,
    TextInput,
} from '@tremor/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApiV1TicketCreate } from '../../api/api.gen'
import { toErrorText } from '../../utilities/error'
import { ModelVMType } from '../../api/api'

export default function LLMModelTicketModal() {
    const [clusterName, setClusterName] = useState<string>('')
    const [nodeType, setNodeType] = useState<ModelVMType>(
        ModelVMType.VMTypeBurstable2Core4GB
    )
    const [llmmodel, setLLMModel] = useState<string>('llama 3.2 8B')

    const {
        response: createTicketResponse,
        isLoading: createTicketLoading,
        isExecuted: createTicketExecuted,
        sendNowWithParams: createTicket,
        error: createError,
    } = useApiV1TicketCreate({}, {}, {}, false)

    const navigate = useNavigate()
    useEffect(() => {
        if (createTicketExecuted && !createTicketLoading) {
            navigate(`/ticket/${createTicketResponse}#close_sidebar_modal`)
        }
    }, [createTicketLoading])

    return (
        <Flex
            className="p-4 bg-gray-50 w-auto max-w-fit rounded-md"
            flexDirection="col"
            justifyContent="start"
            alignItems="start"
        >
            <Text className="mt-4 mb-1">Model name:</Text>
            <TextInput
                value={clusterName}
                onValueChange={setClusterName}
                error={clusterName.length === 0}
                errorMessage="Model name is required"
            />

            <Text className="mt-4 mb-1">LLM Model:</Text>
            <Select
                value={llmmodel}
                onValueChange={setLLMModel}
                error={llmmodel.length === 0}
                errorMessage="LLM Model is required"
            >
                <SelectItem value="llama 3.2 8B">llama3.2 8B</SelectItem>
            </Select>

            <Text className="mt-4 mb-1">Node type:</Text>
            <Select
                value={nodeType}
                onValueChange={(v) => {
                    setNodeType(v as ModelVMType)
                }}
                error={nodeType.length === 0}
                errorMessage="Type is required"
            >
                <SelectItem value={ModelVMType.VMTypeGraphicOptimized8Core32GB}>
                    8cores, 32GB + GPU (NVIDIA T4 16GB)
                </SelectItem>
            </Select>

            <div className="mt-8">{toErrorText(createError)}</div>
            <Button
                className=""
                color="teal"
                loading={createTicketExecuted && createTicketLoading}
                disabled={createTicketExecuted && createTicketLoading}
                onClick={() => {
                    createTicket(
                        {
                            id: 0,
                            newTicket: true,
                            title: 'Request for LLM Model deployment',
                            content: `LLM Model deployment with following configuration
Model name: ${clusterName}
LLM: ${llmmodel}
Node type: ${nodeType}`,
                        },
                        { service: 'LLM Model' },
                        {}
                    )
                }}
            >
                Create
            </Button>
        </Flex>
    )
}
